/**
 * Parent SMS Communications Page
 *
 * Sidebar shortcut for sending instant SMS to parents.
 * Billing is managed exclusively in Family Communications Hub.
 * Any legacy `?tab=billing` URL gracefully falls back to the SMS Portal.
 */
import AppShell from "@/components/layout/AppShell";
import { ParentCommunicationTab } from "@/components/staff-reports/ParentCommunicationTab";

export default function ParentSMSCommunicationsPage() {
  return (
    <AppShell pageTitle="Parent SMS Communications" breadcrumb>
      <ParentCommunicationTab hideBilling={true} />
    </AppShell>
  );
}
